<template>
    <div class="bg-white rounded box-shadow p-3 mb-1" style="padding-bottom:1px!important">
        <div class="row">
            <div v-if="show" class="alert alert-danger alert-dismissible fade show" role="alert">
                <span v-for="(err, index) in validation_errors" :key="index">
                  {{ err[0] }} <br />
                </span>
            </div>
        </div>

        <div class="row">
            <div class="col-md-9">
                <h5 class="float-left">9. For implementing the project what will be the affect in your residence/commercial structure for the following connection</h5>
            </div>
            <div class="col-md-3 float-right">
                <b-button v-b-modal.utilities-connection-modal type="button"
                          @click="resetForm(),$bvModal.show('utilities-connection-modal')"
                          class="btn btn-success float-right btn-sm mb-1 text-black float-right">
                    Add Utilities Connection
                    <i class="fas fa-plus"></i>
                </b-button>
            </div>
        </div>

        <div class="scrollable-table">
            <table class="table table-centered table-striped">
                <thead>
                <tr>
                    <th>SL</th>
                    <th>Land</th>
                    <th>Connection</th>
                    <th>Action</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(land, index) in lands" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>Mouza: {{ land.mouza.mouza_desc }}, Plot: {{ land.plot_no }}, Land Ownership: {{ land.land_ownership_type.land_ownership_type_desc }}</td>
                    <td>
                          <span v-for="(connection, index) in land.connections" :key="index">
                            {{ connection.connection_desc }}
                            <span v-if="index != land.connections.length - 1">| </span>
                          </span>
                    </td>

                    <td>
                      <b-button v-if="land.connections.length == 0" variant="success" class="btn btn-success btn-xs waves-effect waves-light  mr-2" @click.prevent="resetForm(),$bvModal.show('utilities-connection-modal')">
                        <i class="fas fa-plus"></i>
                      </b-button>
                        <b-button v-if="land.connections.length != 0" variant="warning" class="btn btn-warning btn-xs waves-effect waves-light  mr-2" @click.prevent="getLand(land), $bvModal.show('utilities-connection-modal')">
                            <i class="far fa-edit"></i>
                        </b-button>
                        <b-button v-if="land.connections.length != 0" variant="danger" class="btn btn-danger btn-xs waves-effect waves-light" @click.prevent="softDelete(land.id)">
                          <i class="far fa-trash-alt"></i>
                        </b-button>
                    </td>
                </tr>
                </tbody>
            </table>
            <h5 v-if="lands.length === 0" class="text-center text-secondary">
                No Data Found
            </h5>
        </div>

        <utilities-connection-modal
                :land="land"
                :btn_edit="btn_edit"
                @getPersonUtilitiesConnections="getPersonUtilitiesConnections"
                @resetForm="resetForm"
                ref="utilityConnection"
        ></utilities-connection-modal>
    </div>
</template>

<script>
    import appConfig from "@src/app.config";
    import Layout from "@layouts/main";
    import PageHeader from "@components/page-header";
    import http from "@state/http";

    import UtilitiesConnectionModal from "../../modals/UtilitiesConnectionModal";

    export default {
        page: {
            title: "Search Utilities Connection",
            meta: [{name: "description", content: appConfig.description}]
        },
        components: {Layout, PageHeader, UtilitiesConnectionModal},
        data() {
            return {
                title: "Search Utilities Connection",
                items: [
                    {
                        text: 'Dashboard',
                        href: '/',
                    },
                    {
                        text: 'Search',
                        active: true,
                    },
                ],
                lands: [],
                land: {},
                btn_edit: false,
                validation_errors: {},
                show: false,
                cclShow: false,
            };
        },

        mounted() {
            this.land.ses_id = this.$route.params.ses_id;
            let ses_id = this.$route.params.ses_id;
            this.getPersonUtilitiesConnections(ses_id);
        },

        methods: {
            async getLand(land) {
                this.land = {};
                this.btn_edit = true;
                await http.get("api/utilities-connections/" + land.id + "/edit").then(response => {
                    if (!response.error) {
                        this.land = response.data.land;
                    }
                });
            },
             softDelete(land_id) {
                if (confirm("Do you really want to delete?")) {
                    http.delete("api/utilities-connections/" + land_id).then(response => {
                        if (!response.error) {
                            if(response.data.error === true){
                                this.$bvToast.toast(response.data.message, {
                                    title: "Error",
                                    autoHideDelay: 5000,
                                    variant: "danger"
                                });
                            }else{
                                this.$bvToast.toast(response.data.message, {
                                    title: "Success",
                                    autoHideDelay: 5000,
                                    variant: "success"
                                });
                                this.getPersonUtilitiesConnections();
                            }
                        } else {
                            this.$bvToast.toast("Deleted Failed", {
                                title: "Error",
                                autoHideDelay: 5000,
                                variant: "danger"
                            });
                        }
                    });
                }
            },
             getPersonUtilitiesConnections() {
                   http.get("api/utilitiesConnection/getPersonUtilitiesConnection/" + this.land.ses_id)
                      .then(response => {
                          if (!response.error) {
                              this.lands = response.data.lands;
                          }
                      });
              },
               resetForm() {
                let ses_id = this.$route.params.ses_id;
                this.getPersonUtilitiesConnections(ses_id);
                this.btn_edit = false;
                this.land = {};
                this.land.ses_id = this.$route.params.ses_id;
                this.$refs.utilityConnection.getCodes(this.$route.params.ses_id)
              },

        },
    };
</script>
